import styled, { css } from 'styled-components';

import {
  applyStylesForScreenSize,
  SCREEN_SIZES,
} from './utils/screenSizeUtils';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  width: 100%;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      padding-left: 24px;
      padding-right: 24px;
    `,
  )}

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.TABLET],
    css`
      width: 650px;
      max-width: 100%;
      padding-left: 24px;
      padding-right: 24px;
    `,
  )}

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.SMALL_DESKTOP],
    css`
      width: 970px;
    `,
  )}

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.WIDESCREEN],
    css`
      width: 1170px;
    `,
  )}
`;
